import { combineReducers } from 'redux'
import voter from './voter'

export default combineReducers({
    voter,
})


// WEBPACK FOOTER //
// ./src/reducers/index.js